<template>
  <div class="store-setting-page">
    <el-card class="setting-card">
      <div class="card-title">门店设置</div>
      <el-form
        ref="storeFormRef"
        :model="storeForm"
        label-width="120px"
        class="store-form"
      >
        <el-form-item
          v-for="(item, index) in list"
          :label="'店铺' + `${index + 1}:`"
          :key="index"
        >
          <el-input
            v-model="list[index].name"
            placeholder="请输入店铺名称"
            class="store-input"
          />
        </el-form-item>
      </el-form>
      <div class="btn-group">
        <el-button type="primary" class="custom-btn" @click="add"
          >新增</el-button
        >
        <el-button type="primary" class="custom-btn" @click="handleSave"
          >保存</el-button
        >
      </div>
    </el-card>
  </div>
</template>

<script setup>
import { ref, onMounted, getCurrentInstance } from "vue";
const { proxy } = getCurrentInstance();

const list = ref([]);
const storeForm = ref({});
const storeFormRef = ref(null);

// 获取店铺列表
const get = async () => {
  const res = await proxy.$api.Colorcard.get({});
  if (res.data.code == "200") {
    list.value = res.data.data.list;
    console.log("获取店铺列表成功：", list.value);
  } else {
    proxy.$message.error(res.data.msg);
  }
};

//新增店铺
const add = async () => {
  const sendata = {
    name: "",
  };
  const res = await proxy.$api.Colorcard.adds(sendata);
  if (res.data.code == "200") {
    proxy.$message.success("新增店铺成功！");
    get();
  } else {
    proxy.$message.error("新增店铺" + res.data.msg || "新增店铺失败");
  }
};

// 保存按钮
const handleSave = async () => {
  storeFormRef.value.validate(async (valid) => {
    if (valid) {
      const params = {
        storeList: list.value,
      };
      const res = await proxy.$api.Colorcard.update(params);
      if (res.data.code == "200") {
        proxy.$message.success("保存成功！");
      } else {
        proxy.$message.error(res.data.msg || "保存失败");
      }
    } else {
      proxy.$message.error("请检查表单内容");
      return false;
    }
  });
};

onMounted(() => {
  get();
});
</script>

<style scoped>
:deep(.custom-btn) {
  background-color: #ffae00 !important;
  border-color: #ffae00 !important;
  color: #333;
}
.store-setting-page {
  padding: 20px;
  min-height: 100%;
  width: 100%;
}
.setting-card {
  max-width: 800px;
  margin: 50px 5%;
  border-radius: 8px;
}
.card-title {
  font-size: 28px;
  font-weight: 500;
  text-align: center;
  margin-bottom: 30px;
  color: #303133;
}
:deep(.store-form .el-form-item__label) {
  font-size: 24px;
  line-height: 49px;
  color: #303133;
}
.store-input {
  font-size: 24px;
  height: 48px;
  line-height: 48px;
  border: none;
  border-bottom: 1px solid #409eff;
  border-radius: 0;
  padding: 0 4px;
}
:deep(.store-input .el-input__inner) {
  border: none;
  border-bottom: 1px solid #409eff;
  border-radius: 0;
  font-size: 24px;
  height: 48px;
  line-height: 48px;
  background-color: transparent;
}
:deep(.store-input .el-input__inner:focus) {
  border-bottom-color: #66b1ff;
}
.btn-group {
  text-align: center;
  margin-top: 40px;
  padding-bottom: 20px;
}
.btn-group .el-button {
  font-size: 16px;
  padding: 10px 30px;
  margin: 0 10px;
}
</style>
